;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { Bars2Icon } from '@heroicons/react/24/outline'
import { BaseButton } from '@qogita/ui/v2/base-button'
import { ReactNode, useState } from 'react'
import { GREETINGS } from 'src/core/constants/copy'
import { Logo } from 'src/deprecated/components/shared/Logo'
import { MobileSidebar } from 'src/deprecated/components/shared/templates/Sidebar/MobileSidebar'
import { TopBarAccountButton } from 'src/deprecated/components/shared/TopBar/components/TopBarAccountButton'
import { useLogout } from 'src/deprecated/contexts/Authentication'
import { useUserContext } from 'src/deprecated/contexts/User'
import { useLandingRoute } from 'src/deprecated/hooks/utils/useLandingRoute'

export function TopBar(): ReactNode {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const user = useUserContext()
  const landingRoute = useLandingRoute()
  const logout = useLogout()

  const profileButtonText = user?.account ? 'My Portal' : 'Login'
  const profileButtonHref = landingRoute

  return (
    <header className="z-20 flex h-[72px] justify-center border-b border-gray-700 bg-white md:border-b-0">
      <div className="flex h-full w-full max-w-[1072px] flex-row-reverse items-center justify-between px-4 py-4 md:flex-row md:px-6">
        <Logo />

        <div className="flex items-center justify-center">
          <TopBarAccountButton
            href={profileButtonHref}
            className="hidden rounded-full pl-3 md:block"
          >
            <TopBarAccountButton.Greeting
              className="text-right"
              name={user?.account}
              greeting={GREETINGS.hello}
              linkText={profileButtonText}
            />

            <TopBarAccountButton.Icon />
          </TopBarAccountButton>
          {user?.account ? (
            <BaseButton
              onClick={logout}
              aria-label="Sign out"
              // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
              className="hidden h-[72px] items-center px-6 text-base font-semibold outline-hidden hover:bg-gray-200 focus:bg-gray-200 md:flex"
            >
              Sign Out
            </BaseButton>
          ) : null}
        </div>
        <BaseButton
          // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
          className="px-4 text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:outline-hidden focus:ring-inset md:hidden"
          onClick={() => setSidebarOpen(true)}
        >
          <span className="sr-only">Open sidebar</span>
          <Bars2Icon className="h-6 w-6" aria-hidden="true" />
        </BaseButton>
      </div>
      <MobileSidebar open={sidebarOpen} setOpen={setSidebarOpen} />
    </header>
  )
}
